import Details from "@/lib/programContent";
import Style from "@/lib/style";

type Props = {
  programName: string;
};

export default function ProgramCharacteristics(props: Props) {
  let { programName } = props;
  const matchedStyle = Style.find(style => style.title === programName);
  const characteristics = Details[programName].characteristcs;

  return (
    <section className="relative building-image-square md:mt-[-650px]">
      <div className="bigscreen-responsive pt-16 px-6 m-0 md:pl-[500px]">
        <div>
          <div className={`mt-8 uppercase text-2xl ${matchedStyle?.colors?.[0].textColor}`} dangerouslySetInnerHTML={{ __html: characteristics.title(`${matchedStyle?.colors?.[0].textColor}`) }} />
          <p className="text-white text-sm font-thin my-4 max-w-lg md:max-w-2xl md:text-lg">{characteristics.description}</p>
          {characteristics.keyPoints && (
            <ul className="ml-8 mb-3 xl:mb-6 list-disc">
            {characteristics.keyPoints.map((item, index) => (
              <li key={index} className="text-white text-md xl:text-lg my-4" dangerouslySetInnerHTML={{ __html: item }} />
            ))}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
}